const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

const getColorsList = () => {
    return [
        '#ffa8a8',
        '#ffd7a3',
        '#ffeba4',
        '#f3ffa5',
        '#d6ff9c',
        '#a9ffe0',
        '#adf8ff',
        '#a1d3ff',
        '#c3a2ff',
        '#ebabff',
    ];
}

const getElanciaColorsList = () => {
    return [
        '#004851',
        '#7A9A01',
        '#A69F88',
        '#E03C31',
        '#628C91',
        '#51535A',
    ];
}

const getRandomInArray = (array) => {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
};

function increaseSaturation(hex, saturationIncrease = 10) {
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);

    r = r / 255;
    g = g / 255;
    b = b / 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    s = Math.min(s + saturationIncrease / 100, 1);

    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);

    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function increaseDark(hex, darkenAmount = 10) {
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);

    r = r / 255;
    g = g / 255;
    b = b / 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    l = Math.max(l - darkenAmount / 100, 0);

    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);

    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}


function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1/6) return p + (q - p) * 6 * t;
    if (t < 1/2) return q;
    if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
    return p;
}

function componentToHex(c) {
    const hex = Math.round(c * 255).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}

const copyToClipboard = (text, handleSuccess = null) => {
    if (navigator.clipboard && window.isSecureContext) {
        if (handleSuccess) handleSuccess("Copié dans le presse-papier");
        return navigator.clipboard.writeText(text);
    } else {
        let textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
            textArea.remove();
            if (handleSuccess) handleSuccess("Copié dans le presse-papier");
        } catch (err) {
            console.error('Fall back copy to clipboard failed', err);
        }
    }
};

const getNestedValue = (obj, path) => {
    if (typeof path === 'function') {
        return path(obj);
    }

    return path.split('.').reduce((acc, part) => {
        return acc ? acc[part] : undefined;
    }, obj);
};

export const filteredDataTabSearch = (data, colonnes, searchQuery) => {
    return data.filter((datum) => {
        return colonnes.some((column) => {
            const value = getNestedValue(datum, column.accessor);
            return value && value.toString().toLowerCase().includes(searchQuery.toLowerCase());
        });
    });
}


export {
    getRandomColor,
    getColorsList,
    getElanciaColorsList,
    getRandomInArray,
    increaseSaturation,
    increaseDark,
    copyToClipboard,
    getNestedValue
};